import type { SettingListOption } from '@peles/shared';
import { SearchableListSelect } from '../common/SearchableListSelect';

interface SettingListSelectProps {
  options: readonly SettingListOption[];
  /** The stored value, or null for not chosen. */
  value: string | null;
  onChange: (value: string | null) => void;
  label: string;
  /** Shown when the office's list is empty. */
  emptyMessage: string;
  testId?: string;
}

/**
 * A choice from one of the office's settings lists, clearable to "Not
 * chosen". A value since removed from the list is still shown, marked, so
 * opening what holds it never silently changes it.
 */
export function SettingListSelect({
  options,
  value,
  onChange,
  label,
  emptyMessage,
  testId,
}: SettingListSelectProps) {
  const items =
    value && !options.some((o) => o.value === value)
      ? [...options, { value, label: `${value} (no longer in Settings)` }]
      : [...options];
  return (
    <div data-testid={testId}>
      <label className="block text-xs text-gray-500 mb-1">{label}</label>
      <SearchableListSelect
        items={items}
        value={value}
        onChange={(v) => onChange(typeof v === 'string' && v ? v : null)}
        getValue={(o) => o.value}
        getLabel={(o) => o.label}
        placeholder="Not chosen"
        clearable
        ariaLabel={label}
        emptyMessage={emptyMessage}
      />
    </div>
  );
}
